import { SearchQueryParams } from "../search.types";

export const mapBrokerIdsToQuery = (brokersIds: readonly string[]) => {
    return brokersIds?.length > 0 ? `${SearchQueryParams.BrokerIds}=${brokersIds.join(",")}` : "";
};
